export default __webpack_public_path__ + "static/detailImg2-c9aea69ac1669457ca7fc658bd88b90b.webp";